import { useState } from 'react';
import { motion } from 'framer-motion';
import { Button, Input } from '@kamalkari/ui';
import { KolamMandala } from './KolamPattern';

export function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setStatus('loading');
    await new Promise((r) => setTimeout(r, 1000));
    setStatus('success');
    setEmail('');
  };

  return (
    <section className="bg-white py-20 relative overflow-hidden">
      {/* Decorative elements */}
      <KolamMandala className="absolute -left-24 top-1/2 -translate-y-1/2 w-64 h-64 text-warm-100 opacity-50" />
      <KolamMandala className="absolute -right-24 top-1/2 -translate-y-1/2 w-64 h-64 text-warm-100 opacity-50" />

      <div className="container-page relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-2xl mx-auto"
        >
          {/* Gallery-style card */}
          <div className="bg-warm-50 border border-warm-200 p-8 sm:p-12 text-center">
            <p className="text-xs font-medium tracking-[0.3em] uppercase text-ochre mb-4">
              Gallery Newsletter
            </p>
            <h2 className="text-3xl sm:text-4xl font-serif text-warm-900 mb-4">
              Join Our Art Circle
            </h2>
            <p className="text-warm-600 mb-8 max-w-md mx-auto">
              Be the first to know about new collections, exclusive exhibitions,
              and stories behind the art. Plus, receive a special welcome gift.
            </p>

            {status === 'success' ? (
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                className="bg-white border border-warm-200 rounded p-6"
              >
                <div className="w-12 h-12 bg-ochre/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-6 h-6 text-ochre" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-warm-900 font-medium mb-2">Welcome to the Art Circle!</p>
                <p className="text-warm-600 text-sm">
                  Check your inbox for your welcome gift and first glimpse into our gallery.
                </p>
              </motion.div>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
                <Input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 bg-white border-warm-300 text-warm-900 placeholder:text-warm-400"
                  required
                />
                <Button
                  type="submit"
                  disabled={status === 'loading'}
                  className="bg-warm-900 hover:bg-warm-800 text-white"
                >
                  {status === 'loading' ? 'Joining...' : 'Join'}
                </Button>
              </form>
            )}

            <p className="text-warm-400 text-xs mt-6">
              We respect your privacy. Unsubscribe anytime.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
